import { render, staticRenderFns } from "./PessoaForm.vue?vue&type=template&id=040dae34"
import script from "./PessoaForm.vue?vue&type=script&lang=js"
export * from "./PessoaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports